import React from "react";
import { IContextualMenuProps, Stack } from "@fluentui/react";
import { DefaultButton, PrimaryButton } from "@fluentui/react/lib/Button";
import { red } from "@material-ui/core/colors";
import { useTranslation } from "react-i18next";

interface IProps {
  onConfirmClick?: () => void;
  onCancelClick?: () => void;
  onDeleteClick?: () => void;
  confirmIcon?: string;
  cancelIcon?: string;
  deleteIcon?: string;
  confirmText?: string;
  cancelText?: string;
  deleteButtonId?: string;
  cancelMenuProps?: IContextualMenuProps;
  deleteText?: string;
  disabled: boolean;
  confirmButtonVisible: boolean;
  cancelButtonVisible: boolean;
  deleteButtonVisible: boolean;
}
export default function FormButtons({
  onConfirmClick,
  onCancelClick,
  onDeleteClick,
  confirmIcon,
  cancelIcon,
  deleteIcon,
  confirmText,
  cancelText,
  deleteButtonId,
  cancelMenuProps,
  deleteText,
  disabled,
  confirmButtonVisible,
  cancelButtonVisible,
  deleteButtonVisible,
}: IProps) {
  const { t } = useTranslation();
  return (
    <Stack horizontal tokens={{ childrenGap: 16 }} horizontalAlign="end">
      {confirmButtonVisible && (
        <PrimaryButton
          text={confirmText ?? t("common.save")}
          onClick={onConfirmClick}
          iconProps={{ iconName: confirmIcon ?? "Save" }}
          disabled={disabled}
        />
      )}
      {cancelButtonVisible && (
        <DefaultButton
          text={cancelText ?? t("common.cancel")}
          menuProps={cancelMenuProps}
          onClick={onCancelClick}
          iconProps={{ iconName: cancelIcon ?? "Cancel" }}
          disabled={disabled}
        />
      )}
      {deleteButtonVisible && (
        <PrimaryButton
        id={deleteButtonId}
          text={deleteText ?? t("common.delete")}
          onClick={onDeleteClick}
          iconProps={{ iconName: deleteIcon ?? "Delete" }}
          disabled={disabled}
          style={{ backgroundColor: red[500], borderColor: red[500] }}
        />
      )}
    </Stack>
  );
}

FormButtons.defaultProps = {
  confirmButtonVisible: true,
  cancelButtonVisible: true,
  deleteButtonVisible: false,
  disabled: false,
};
